export const siteConfig = {
  name: '黑料不打烊',
  tagline: '娱乐圈劲爆内幕全天候不停更',
  description: '黑料不打烊，24小时滚动更新娱乐圈最新黑料、明星丑闻、劲爆内幕与独家爆料。无论何时到访，黑料不打烊始终为你送上最新鲜、最真实的圈内秘闻，让你不错过任何一条热辣资讯。',
  url: 'https://heiliaobudayang.com',
  foundingYear: '2024',
  founder: '吃瓜编辑部',
  email: 'tips@heiliaobudayang.com',
  address: '北京市朝阳区建国路88号SOHO现代城A座',
  phone: '010-8888-6666',
  socialLinks: {
    weibo: 'https://weibo.com/heiliaobudayang',
    wechat: 'heiliaobudayang',
    douyin: 'https://douyin.com/@heiliaobudayang',
  },
};

export const testimonials = [
  {
    name: '小张',
    role: '忠实读者',
    content: '每天都在刷黑料不打烊，更新速度太快了！娱乐圈的最新动向这里都有，比微博热搜还快。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20person%20portrait%2C%20casual%20style%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
  },
  {
    name: '阿花',
    role: '吃瓜群众',
    content: '黑料不打烊是我每天的快乐源泉！不仅料多料猛，关键是真实可靠，不是那种编造的假新闻。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%2C%20casual%20style%2C%20natural%20smile%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
  },
  {
    name: '老刘',
    role: '资深娱记',
    content: '作为同行，我不得不说黑料不打烊的爆料质量和速度在业内是数一数二的。很多料我们都要从这里获取线索。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20middle-aged%20Chinese%20man%20portrait%2C%20professional%20look%2C%20confident%20expression%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
  },
  {
    name: '小美',
    role: '追星女孩',
    content: '说实话又爱又怕，爱的是料多到吃不完，怕的是哪天我家爱豆也上黑料不打烊了...但忍不住还是要看！',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20girl%20portrait%2C%20trendy%20style%2C%20playful%20expression%2C%20clean%20white%20background%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-04&orientation=squarish',
  },
];

export const faqData = [
  {
    question: '黑料不打烊的爆料信息可靠吗？',
    answer: '我们拥有遍布娱乐圈的独家线人网络，每一条爆料都经过多方交叉验证后才发布。虽然我们无法保证100%准确，但我们的信息可靠性在业内是有口皆碑的。对于未经证实的信息，我们会明确标注"传闻"或"据知情人士透露"。',
  },
  {
    question: '如何向黑料不打烊提供爆料线索？',
    answer: '欢迎通过我们的官方邮箱 tips@heiliaobudayang.com 提交爆料线索。我们对线人的身份信息严格保密，绝不泄露来源。如果你的爆料被采用，还可以获得丰厚的线索奖励。',
  },
  {
    question: '网站更新频率是怎样的？',
    answer: '正如我们的名字——黑料"不打烊"，我们实行24小时不间断更新机制。编辑团队三班倒值班，确保无论何时打开网站，都能看到最新的娱乐圈动态。重大爆料更是会在第一时间推送。',
  },
  {
    question: '被爆料方要求删帖怎么办？',
    answer: '我们始终坚持新闻真实性的原则。只有在以下情况下我们会考虑修改或删除内容：1）经证实信息确实有误；2）涉及个人隐私且不涉及公众利益；3）法律要求。我们拒绝一切以公关为目的的删帖要求。',
  },
  {
    question: '可以在其他平台转载黑料不打烊的内容吗？',
    answer: '欢迎转载，但请务必注明出处"黑料不打烊"并附上原文链接。对于未注明出处的搬运行为，我们将保留追究法律责任的权利。商业媒体转载请先联系我们获取授权。',
  },
];